// @flow

export default window;

// Global functions (grobot.js)
export const menu_translate = window.menu_translate;
export const clear_old_page = window.clear_old_page;
export const trans_table = window.trans_table;
export const lang_decimalSep = window.lang_decimalSep;
export const load_conf = window.load_conf;
export const limit_strlen = window.limit_strlen;
export const alert = window.alert;
export const recorrect_all_grid_rows: () => void = window.recorrect_all_grid_rows;
export const make_a_results_page = window.make_a_results_page;
export const make_a_measurement_page = window.make_a_measurement_page;
export const getWagonInfo = window.getWagonInfo;
